import { render } from "./DiscussionCommentForm.vue?vue&type=template&id=4bef2eea&scoped=true"
import script from "./DiscussionCommentForm.vue?vue&type=script&lang=js"
export * from "./DiscussionCommentForm.vue?vue&type=script&lang=js"

import "./DiscussionCommentForm.vue?vue&type=style&index=0&id=4bef2eea&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bef2eea"]])

export default __exports__